import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';
import FacebookSocialPlugin from './FacebookSocialPlugin';
import SkyringView from './SkyringView';
import CommentsForm from './CommentsForm';

import nyyrdiHelper from './../nyyrdiHelper';

class EntryView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/nyyrdi/';

		this.upvoteHandler = this.upvoteHandler.bind(this);
		this.downvoteHandler = this.downvoteHandler.bind(this);
		this.sendCommentHandler = this.sendCommentHandler.bind(this);

		this.eventBusVotingSuccessHandler = this.eventBusVotingSuccessHandler.bind(this);
		this.eventBusCommentSendSuccessHandler = this.eventBusCommentSendSuccessHandler.bind(this);

		this.state = {};
	}

	componentDidMount() {
		window.EventBus.addEventListener('success.voting', this.eventBusVotingSuccessHandler);
		window.EventBus.addEventListener('success.sendcomment', this.eventBusCommentSendSuccessHandler);

		if (this.props.match && this.props.match.params.nyyrdi) {
			this.fetchData();
		}
		else if (this.props.data) {
			this.setState({
				data: this.props.data
			});
		}
	}

	componentWillUnmount() {
		window.EventBus.removeEventListener('success.voting', this.eventBusVotingSuccessHandler);
		window.EventBus.removeEventListener('success.sendcomment', this.eventBusCommentSendSuccessHandler);
	}

	componentDidUpdate(prevProps, prevState) {
		// Athuga hvort breytur hafi breyst og hvort component eigi að uppfærast
		if (this.props.match && this.props.match.params.nyyrdi && prevProps.match.params.nyyrdi != this.props.match.params.nyyrdi) {
			this.fetchData();
		}
	}

	eventBusVotingSuccessHandler(event) {
		let dataItem = this.state.data || null;

		if (dataItem && dataItem.skyringar && dataItem.skyringar.length > 0) {
			dataItem.skyringar.forEach(function(skyring) {
				if (skyring.id == event.target.skyring) {
					skyring.downvotes = event.target.downvotes,
					skyring.upvotes = event.target.upvotes
				};
			});

			this.setState({
				data: dataItem
			});
		}
	}

	eventBusCommentSendSuccessHandler(event) {
		let dataItem = this.state.data || null;

		if (dataItem && dataItem.athugasemdir) {
			dataItem.athugasemdir.unshift(event.target.comment);

			this.setState({
				data: dataItem
			});
		}
	}

	// Handlerar sem taka við skilaboðum frá SkyringView um að senda þurfi upvote, downvote eða athugasemd til vefþjóns
	// Í þessum sendum við gögnin með EventBus til App componentsins sem sér um öll POST samskipti við server og grecaptcha auðkenningu
	upvoteHandler(event) {
		window.EventBus.dispatch('data.send', {
			type: 'upvote',
			id: event
		});
		return;
	}

	downvoteHandler(event) {
		window.EventBus.dispatch('data.send', {
			type: 'downvote',
			id: event
		});
	}

	sendCommentHandler(event) {
		window.EventBus.dispatch('data.send', {
			type: 'sendcomment',
			id: this.state.data.id,
			comment: event
		})
	}

	fetchData() {
		// Sæki gögn til APA

		this.setState({
			initialized: false
		});

		fetch(this.url+this.props.match.params.nyyrdi)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: json
				});

				setTimeout(function() {
					this.setState({
						initialized: true
					});
				}.bind(this), 200);
			}.bind(this));
	}

	render() {
		let singleItem = this.props.singleItem;
		let dataItem = this.state.data || null;

		let EntryTag = singleItem ? 'div' : 'a';

		let word;
		if (dataItem && dataItem.id) {
			word = dataItem.ord.length > 80 ? dataItem.ord.substr(0, 80)+'...' : dataItem.ord;
		}

		return (
			<EntryTag href={!singleItem && dataItem && dataItem.id ? '/nyyrdi/'+dataItem.id : ''} 
				className={'word-entry'+(singleItem ? ' single' : '')+(this.state.initialized ? ' initialized' : '')} 
				style={{transitionDelay: ((this.props.index || 0)*50 < 1000 ? (this.props.index || 0)*50 : 1000)+'ms'}}>
				{
					dataItem && dataItem.id &&
					<React.Fragment>
						<div className="word-item">

							{
								singleItem &&
								<div className="item-title">Nýyrðið er</div>
							}

							<div className="inner-frame">
								<div className={'word-display'+(dataItem.ord.length > 12 ? ' long-word' : '')+(dataItem.ord.length > 10 ? ' medium-word' : '')}>{singleItem ? dataItem.ord : word}</div>
								<p><strong>{nyyrdiHelper.capitalizeFirstLetter(nyyrdiHelper.ordflokkar[dataItem.ordflokkur])}{dataItem.kyn ? ', '+dataItem.kyn : ''}</strong></p>
								{

									// Birting á einstöku nýyrði

									singleItem &&
									<React.Fragment>
										{
											dataItem.samheiti && dataItem.samheiti.length > 0 &&
											<p>
												<strong>Samheiti: </strong>{dataItem.samheiti.join(', ')}
											</p>
										}
										<h4><span>Skýringar</span></h4>
										<div className="skyringar">
											{
												dataItem.skyringar.map(function(skyring, index) {
													return <SkyringView key={index} index={index} data={skyring} onUpvote={this.upvoteHandler} onDownvote={this.downvoteHandler} />
												}.bind(this))
											}
										</div>

										{
											dataItem.flokkar && dataItem.flokkar.length > 0 &&
											<React.Fragment>
												<h4><span>Flokkun</span></h4>
												<div className="mb-4">
													{
														dataItem.flokkar.map(function(item, index) {
															return <Link className="btn btn-secondary btn-small" to={'/leit//flokkur/'+item.id}>{item.heiti}</Link>
														})
													}
												</div>
											</React.Fragment>
										}

										{
											dataItem.tenglar && dataItem.tenglar.length > 0 &&
											<React.Fragment>
												<h4><span>Ítarefni</span></h4>
												<div className="mb-4">
													{
														dataItem.tenglar.map(function(item, index) {
															return <a className="btn btn-link btn-small" href={item.url}>{item.titill}</a>
														})
													}
												</div>
											</React.Fragment>
										}
										<div className="word-footnote">
											<small>Sett inn: {nyyrdiHelper.formatDate(dataItem.inserttime, true)}</small>
										</div>

									</React.Fragment>
								}
								{

									// Birting á nýyrðum í lista

									!singleItem &&
									<React.Fragment>
										<div className="hover-info">
											<div className="hover-content">
												<div className={'word-display'+(dataItem.ord.length > 12 ? ' long-word' : '')+(dataItem.ord.length > 10 ? ' medium-word' : '')}>{word}</div>
												{/*<div>Nánar um nýyrðið „{dataItem.ord}“.<br/>Hægt er að gefa því einkunn og sjá og skrifa athugasemdir um það.</div>*/}
												<div>Nánar um nýyrðið „{word}“.</div>
											</div>
										</div>
										<div className="description">
											{
												dataItem.skyringar.map(function(skyring, index) {
													return <span key={index} className="item">
														{skyring.merking.length > 100 ? skyring.merking.substr(0, 100)+'...' : skyring.merking} 
														<span className="votes">
															<span className="vote upvotes">{skyring.upvotes}</span>
															<span className="vote downvotes">{skyring.downvotes}</span>
														</span>
													</span>;
												}.bind(this))
											}
											{
												<p className="mt-3">
													<small>
														{
															dataItem.athugasemdir_count == 0 ? 'Engar athugasemdir' :
															dataItem.athugasemdir_count == 1 ? '1 athugasemd' :
															dataItem.athugasemdir_count+' athugasemdir'
														}
													</small>
												</p>
											}
										</div>
									</React.Fragment>
								}
	
							</div>

							{/*
								!singleItem &&
								<div className="frame-footer"><Link to={'/nyyrdi/'+dataItem.id}>Nánar um nýyrðið</Link></div>
							*/}
						</div>

						{
							singleItem &&
							<div className="entry-footer">
								<h3><span>Hvað segir þú um þetta?</span></h3>

								<CommentsForm entryData={dataItem} onSendComment={this.sendCommentHandler} />
							</div>
						}
					</React.Fragment>
				}

			</EntryTag>
		);
	}
}

export default EntryView;



// WEBPACK FOOTER //
// ./src/components/EntryView.js